import * as React from "react"
import Title from "../general/title"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faHourglassHalf, faLightbulb, faThumbsUp, faPaperPlane} from '@fortawesome/free-regular-svg-icons'
import {faAlignLeft, faHighlighter, faNewspaper, faQuoteLeft} from '@fortawesome/free-solid-svg-icons'
import LazyImage from "../general/lazyImage"
import Translate from '../general/translate'

const Featuresection = () => {
    const [loadVideo, setLoadVideo] = React.useState(false);
    const videoContainerRef = React.useRef(null);
  
    React.useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setLoadVideo(true);
            observer.disconnect(); // Stop observing once the video is loaded
          }
        },
        {
          threshold: 0.1 // Load the video when at least 10% of the video container is visible
        }
      );
  
      observer.observe(videoContainerRef.current);
      return () => observer.disconnect(); // Cleanup
    }, []);

   return (
    <div className="py-14 bg-[#FAFAFA] " id="contentsection">
        <div className="md:mb-14 mb-10 mx-auto lg:w-3/5  w-full px-6 lg:px-10" ref={videoContainerRef}>
            <div className="relative w-full pb-[56.25%] h-0"> 
                {loadVideo ? ( 
                    <iframe src="https://www.youtube.com/embed/_RdzCsaRuGs?si=aVKKF-Gqa5riLImt" frameborder="0" allowfullscreen className="absolute top-0 left-0 w-full h-full"></iframe> 
                ) : ( 
                    <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 text-white flex items-center justify-center">
                        <Translate id="loading" foldername="home" filename="home-featuressection" />
                    </div> 
                )} 
            </div>
        </div>
        <div className="px-6 max-w-7xl m-auto">
            <div className="container mx-auto flex flex-col lg:flex-row items-start lg:items-center space-y-6 lg:space-y-0 lg:space-x-12">
               
                <div className="lg:w-1/2 flex flex-col justify-center">                    
                    <h2 className="text-[#27004F] text-3xl leading-tight md:text-5xl font-extrabold leading-tight ">
                        <span className=""><Translate id="transcribe_and_write_show_notes" foldername="home" filename="home-featuressection" /></span>
                        <span className="text-[#643ADA] font-extrabold"> <Translate id="twenty_times_faster" foldername="home" filename="home-featuressection" /></span>
                    </h2>
                    <p className="text-[#27004F] text-xl opacity-60 mt-6 lg:w-5/6">
                        <Translate id="save_manual_work" foldername="home" filename="home-featuressection" />
                    </p>
                    <a href="/squeeze" className="transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 bg-[#FFCA1D] text-[#483187] mt-10 font-bold text-xl px-8 py-4 rounded-[8px] shadow hover:shadow-lg self-start hidden md:inline-block">
                        <Translate id="generate_content" foldername="home" filename="home-featuressection" />
                    </a>
                </div> 
                
                <div className="lg:w-1/2 grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="bg-[#643ADA] bg-opacity-5 p-6 rounded-3xl">
                        <div className="mb-2">
                            <FontAwesomeIcon icon={faAlignLeft} className="text-[#FD9B79] text-2xl" />
                            <h3 className="text-[#27004F] text-2xl font-bold mt-2">
                                <Translate id="transcripts" foldername="home" filename="home-featuressection" />
                            </h3>
                        </div>
                        <p className="text-[#27004F] text-md opacity-60">
                            <Translate id="full_transcript" foldername="home" filename="home-featuressection" />
                        </p>
                    </div>
                    <div className="bg-[#643ADA] bg-opacity-5 p-6 rounded-3xl">
                        <div className="mb-2">
                            <FontAwesomeIcon icon={faHighlighter} className="text-[#3ADAD9] text-2xl" />
                            <h3 className="text-[#27004F] text-2xl font-bold mt-2">
                                <Translate id="show_notes" foldername="home" filename="home-featuressection" />
                            </h3>
                        </div>
                        <p className="text-[#27004F] text-md opacity-60">
                            <Translate id="summarize_and_generate_show_notes" foldername="home" filename="home-featuressection" />
                        </p>
                    </div>
                    <div className="bg-[#643ADA] bg-opacity-5 p-6 rounded-3xl">
                        <div className="mb-2">
                            <FontAwesomeIcon icon={faPaperPlane} className="text-[#FFCA1D] text-2xl" />
                            <h3 className="text-[#27004F] text-2xl font-bold mt-2">
                                <Translate id="blog_and_newsletter" foldername="home" filename="home-featuressection" />
                            </h3>
                        </div>
                        <p className="text-[#27004F] text-md opacity-60">
                            <Translate id="actionable_blog_posts" foldername="home" filename="home-featuressection" />
                        </p>
                    </div>
                    <div className="bg-[#643ADA] bg-opacity-5 p-6 rounded-3xl">
                        <div className="mb-2">
                            <FontAwesomeIcon icon={faThumbsUp} className="text-[#4A81EC] text-2xl" />
                            <h3 className="text-[#27004F] text-2xl font-bold mt-2">
                                <Translate id="social_media" foldername="home" filename="home-featuressection" />
                            </h3>
                        </div>
                        <p className="text-[#27004F] text-md opacity-60">
                            <Translate id="short_posts_and_insights" foldername="home" filename="home-featuressection" />
                        </p>
                    </div>
                </div>
            </div>
            <a href="/squeeze" className="transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 bg-[#FFCA1D] text-[#483187] mt-10 font-bold text-xl px-8 py-4 rounded-[8px] shadow hover:shadow-lg self-start inline-block md:hidden">
                <Translate id="generate_content" foldername="home" filename="home-featuressection" />
            </a>
        </div>

        <div className="max-w-2xl w-3/4 m-auto mb-0 md:mb-8 mt-12 text-center">
            <div className="flex flex-col sm:flex-row items-center justify-center">
                <LazyImage src="/home/justinjackson.webp" className="h-24 w-24 md:h-32 md:w-32 rounded-full cursor-pointer mt-5 mb-0 sm:mt-0 sm:mb-0 sm:mr-5" alt="Justin Jackson Co-founder of transistor" />
                <div className="text-left">
                    <FontAwesomeIcon icon={faQuoteLeft} className="text-[#27004F] text-2xl" />
                    <p className="text-[#27004F] opacity-80 mb-4 text-sm sm:text-md items-center italic font-semibold leading-tight">
                        <Translate id="testimonial" foldername="home" filename="home-featuressection" />
                    </p>
                    <p className="text-[#27004F] text-sm font-bold">Justin Jackson</p>
                    <p className="text-[#27004F] text-sm">
                        <Translate id="cofounder_transistor" foldername="home" filename="home-featuressection" />
                    </p>
                </div>
            </div>
        </div>
    </div> 
  )
}

export default Featuresection